import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/common.json";
import ja from "./locales/ja/common.json";

// import de from "./locales/de/common.json";
// import it from "./locales/it/common.json";

// import sv from "./locales/sv/common.json";
// import es from "./locales/es/common.json";
// import fr from "./locales/fr/common.json";
// import ko from "./locales/ko/common.json";
// import pt from "./locales/pt/common.json";
// import zh from "./locales/zh/common.json";

const resources = {
  en: {
    translation: en,
  },
  ja: {
    translation: ja,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
